module.exports = __webpack_public_path__ + "static/img/jiandna@2x.68019d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/jiandna@2x.png
// module id = ogXF
// module chunks = 1